import { PathElementNodeCurvetoQuadratic } from "./PathElementNodeCurvetoQuadratic";

/**
 * Path absolute CurveTo command, e.g. "C 50,50 100,-50 100,200"
 */
export class PathElementNodeCurvetoBezier extends PathElementNodeCurvetoQuadratic {
    public cx2: number;
    public cy2: number;

    constructor(cx1: number, cy1: number, cx2: number, cy2: number, x: number, y: number) {
        super(cx1, cy1, x, y);
        this.cx2 = cx2;
        this.cy2 = cy2;
        this.command = "C";
    }

    public draw(graphics: PIXI.Graphics) {
        graphics.bezierCurveTo(this.cx1, this.cy1, this.cx2, this.cy2, this.x, this.y);
    }

    public clone(): PathElementNodeCurvetoBezier {
        return new PathElementNodeCurvetoBezier(this.cx1, this.cy1, this.cx2, this.cy2, this.x, this.y);
    }

    public setInterpolatedTo(
        from: PathElementNodeCurvetoBezier,
        to: PathElementNodeCurvetoBezier,
        ratio: number,
    ): void {
        this.x = from.x + (to.x - from.x) * ratio;
        this.y = from.y + (to.y - from.y) * ratio;
        this.cx1 = from.cx1 + (to.cx1 - from.cx1) * ratio;
        this.cy1 = from.cy1 + (to.cy1 - from.cy1) * ratio;
        this.cx2 = from.cx2 + (to.cx2 - from.cx2) * ratio;
        this.cy2 = from.cy2 + (to.cy2 - from.cy2) * ratio;
    }

    public equalTo(to: PathElementNodeCurvetoBezier): boolean {
        return (
            this.x === to.x &&
            this.y === to.y &&
            this.cx1 === to.cx1 &&
            this.cy1 === to.cy1 &&
            this.cx2 === to.cx2 &&
            this.cy2 === to.cy2
        );
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PathElementNodeCurvetoBezier.ts
 **/